module.exports = __webpack_public_path__ + "img/HQ-OA-360V06NL_ALL.2aa9e662.jpg";